import { forwardRef, type ReactElement } from 'react';
import cx from 'clsx';
import { Button, type ButtonProps } from 'react-aria-components';
import styles from './trigger.module.css';

interface TriggerProps extends ButtonProps {
  isReadOnly?: boolean;
}

export const Trigger = forwardRef<HTMLButtonElement, TriggerProps>(
  ({ className, isReadOnly, ...props }, ref): ReactElement => {
    return (
      <Button
        ref={ref}
        className={cx(styles.trigger, className, isReadOnly && styles['trigger--readonly'])}
        data-readonly={isReadOnly}
        {...props}
      />
    );
  }
);

Trigger.displayName = 'Trigger';
